import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from 'src/app/shared/session';
import { SessionInfo } from 'src/app/shared/session/SessionInfo';

@Injectable({
  providedIn: 'root'
})
export class ZonaRegionService {

  constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

  private saveZonaRegionUrl: string = 'zonaRegion/save';
  private listarZonaRegionPorUrl: string = 'zonaRegion/listarPor';

  guardarZonaRegion(idZona: number, idRegion: number): any {
    let parameters: string;
    parameters = JSON.stringify({
      idZona: idZona,
      idRegion: idRegion,
    });
    this.dataService.set(this.saveZonaRegionUrl);
    return this.dataService.execPostJson(parameters);
  }

  listarZonaRegion(filtro: string, idZona: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", filtro);
    parameters = parameters.append("idEmpresa", String(this.sessionInfo.getEmpresaID()));
    parameters = parameters.append("idZona", String(idZona));
    this.dataService.set(this.listarZonaRegionPorUrl);
    return this.dataService.execGetJson(parameters);
  }
}
